import { Component, Inject, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { KeyResult, ObjectiveTask } from '../../models/objectives';
import { ObjectivesService } from '../../services/objectives.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-update-task-dialog',
    templateUrl: './update-task-dialog.component.html',
    styleUrls: ['./update-task-dialog.component.css'],
    imports: [ReactiveFormsModule, CdkScrollable, MatDialogContent, MatFormField, MatLabel, MatInput, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, MatDialogActions, MatButton, MatDialogClose]
})
export class UpdateTaskDialogComponent implements OnInit {

  task: ObjectiveTask;
  taskForm;

  constructor(public dialogRef: MatDialogRef<UpdateTaskDialogComponent>,
    private fb: UntypedFormBuilder,
    private objectiveSrv: ObjectivesService,
    @Inject(MAT_DIALOG_DATA) private data: {Task: ObjectiveTask},
    ) { }

  ngOnInit(): void {
    this.task = this.data.Task;

    this.taskForm = this.fb.group({
      TaskId: [this.data.Task.TaskId],   
      Completed: [true],   
      CompletedComment: [''],
      CompletedDate:[new Date(), Validators.required]
      
    });
  }

  onSubmit(){
    console.log(this.taskForm.value);
    this.objectiveSrv.updateTaskComplete(this.taskForm.value).subscribe(res =>{
      if(res)
        this.dialogRef.close();
    });
  }

}
